import { defineStore } from 'pinia'

export const useAlertStore = defineStore({
  id: 'alert',
  state: () => ({
    updateData: null,
    domain: null,
    alertPopUp: localStorage.getItem('alertPopUp') || 'false',
    alertDataObj: JSON.parse(localStorage.getItem('alertDataObj')) || [],
  }),
  actions: {
    updateAlertDataFunc(value) {
      this.updateData = value
    },
    updateDomain(value) {
      this.domain = value
    },
    updateAlertDataObj(value) {
      localStorage.setItem('alertDataObj', JSON.stringify(value))
      this.alertDataObj = value
    },
  },
})
